import { fromZonedTime } from 'date-fns-tz';

export const isProd = process.env.NEXT_PUBLIC_APP_ENV === 'production';
export const isStaging = process.env.NEXT_PUBLIC_APP_ENV === 'staging';
export const isTest = process.env.NEXT_PUBLIC_APP_ENV === 'test';
export const isDevelopment = process.env.NEXT_PUBLIC_APP_ENV === 'development';

/**
 * Dev workaround: `appointments.created_at` is TIMESTAMP WITHOUT TIME ZONE.
 * TypeORM reads the correct UTC value but applies an extra local-tz offset in dev.
 * `fromZonedTime` compensates. Production (UTC server) is unaffected.
 *
 * TODO: Remove once appointments.created_at is migrated to TIMESTAMPTZ.
 */
export const getEffectiveStartTime = (startTime: Date): Date => {
  return isDevelopment ? new Date(fromZonedTime(startTime, 'UTC')) : startTime;
};

export const getPatientAppUrl = () =>
  process.env.NEXT_PUBLIC_BERRY_STREET_PATIENT_APP_URL;

/**
 * Safely calculates session duration in minutes, protecting against negative values
 * that can occur due to system clock changes or other timing issues
 *
 * @param startTime - Session start time
 * @param endTime - Session end time (defaults to current time)
 * @returns Duration in minutes, never negative, minimum 0
 */
export const calculateSafeDuration = (
  startTime: Date,
  endTime: Date = new Date(),
): number => {
  if (!startTime || !endTime) {
    return 0;
  }

  const durationMs = endTime.getTime() - startTime.getTime();
  const durationMinutes = Math.round(durationMs / 60000);

  // Protect against negative durations (system clock changes, etc.)
  return Math.max(0, durationMinutes);
};
